module.exports = __webpack_public_path__ + "static/img/gt.a0bc1cdc.svg";